import { Component, Input, inject } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { AsyncPipe, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectOption } from '../../../../_interfaces/select-field.interface';
import { BoFormsModule, FieldPathDirective, FormFieldComponent, FormOptionsDirective } from '@bo/ng-forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-select-field',
  imports: [NgSelectModule, FormsModule, BoFormsModule, NgClass, AsyncPipe],
  templateUrl: './select-field.component.html',
})
export class SelectFieldComponent extends FormFieldComponent {
  protected formOptionsDirective: FormOptionsDirective;
  protected override fieldPathDirective: FieldPathDirective;

  @Input() options!: Observable<SelectOption[]>;
  @Input() multiple: boolean = false;
  @Input() searchable: boolean = false;
  @Input() boFieldPath?: string;
  @Input() override hideLabel: boolean = false;
  @Input() clearable: boolean = true;
  @Input() override label!: string;
  @Input() placeholder: string = '';
  @Input() closeOnSelect: boolean = false;
  @Input() maxLength: number = 1000;
  @Input() readonly: boolean = false;

  constructor() {
    const formOptionsDirective = inject(FormOptionsDirective);
    const fieldPathDirective = inject(FieldPathDirective);

    super(formOptionsDirective, fieldPathDirective);

    this.formOptionsDirective = formOptionsDirective;
    this.fieldPathDirective = fieldPathDirective;
  }
}
